import { Button } from '@/components/Common';
import { useEvaluationStore } from '@/store/EvaluationStore/EvaluationStore';
import evaluationIcon from '@/assets/icons/evaluation.svg';
export const EvaluationEmpty = () => {
  const { setIsOpenModal } = useEvaluationStore();

  return (
    <>
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="flex flex-col items-center justify-center">
          <img src={evaluationIcon} alt="evaluation" />
          <h1 className="text-2xl font-normal w-[538px] text-center text-[#8080808C] my-16">
            Aucun exercice disponible pour cette évaluation veuillez en créer un
          </h1>
          <Button
            title="Ajouter Nouvel Exercice"
            onClick={() => setIsOpenModal(true)}
          />
        </div>
      </div>
    </>
  );
};
